import React from 'react'

/** What the company-search inputs report back when the user changes the company data. */
export type FormChangeArgs = {
  dataEntry?: string
  valueSelected?: boolean | string
  hasLegalFormValue?: boolean
  hasWebsiteValue?: boolean
}

export const FormChangeContext = React.createContext<{
  onChange: (args: FormChangeArgs) => void
  discardChangeCounter: number | undefined
}>({
  onChange: () => null,
  discardChangeCounter: 0,
})

export const SelectedCountryContext = React.createContext<string | undefined | null>(null)

export const SelectedStateContext = React.createContext<string | undefined | null>(null)
